import { NgModule } from '@angular/core';
import { FlightDetailsComponent } from '@ibe.components/shared/flight-details/flight-details.component';
import { INDRAFlightDetailsComponent } from '@ibe.components/shared/flight-details/flight-details.indra.component';
import { CommonModule } from '@angular/common';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { DirectivesModule } from 'src/app/directives/directives.module';

@NgModule({
  imports: [CommonModule, TAPCommonModule, DirectivesModule],
  declarations: [FlightDetailsComponent, INDRAFlightDetailsComponent],
	exports: [INDRAFlightDetailsComponent]
})
export class FlightDetailsModule { }
